var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "800px", height: "520px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.popClose()
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("msg.ONEX010P100.032")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _vm.type === "D" || _vm.type === "F"
              ? _c("p", { staticClass: "color_red font_12 mb5" }, [
                  _vm._v(_vm._s(_vm.$t("msg.NEWB020P030.016"))),
                ])
              : _vm._e(),
            _vm.type === "D" || _vm.type === "F"
              ? _c("p", { staticClass: "color_red font_12 mb5" }, [
                  _vm._v(_vm._s(_vm.$t("msg.NEWB020P030.018"))),
                ])
              : _vm._e(),
            _vm._l(_vm.guideTextList, function (guideText, idx) {
              return _c("div", { key: idx, staticClass: "mb5" }, [
                _c("p", { staticClass: "color_red font_12 mb5" }, [
                  _vm._v(_vm._s(guideText)),
                ]),
              ])
            }),
            _c("DEXT5Upload", {
              ref: "dextupload_docPop",
              attrs: {
                id: "dextupload_docPop",
                width: "100%",
                height: "200px",
                single: _vm.singleFileYn,
                "file-info": _vm.parentInfo,
                "file-ext": _vm.fileExt,
                category: _vm.categoryInfo.length > 0,
                "category-info": _vm.categoryInfo,
              },
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "mt10 text_center" }, [
        _c(
          "a",
          {
            staticClass: "button blue lg",
            on: {
              click: function ($event) {
                return _vm.popClose()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("msg.VOSD100.041")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }